/**
 * Main Feed Page Style
 *
 * @author Creator-Solutions -> Owen Burns
 */

import styled from "styled-components";

const FeedPageContainer = styled.div`
  width: 38vw;
  height: 100%;
  margin: 25px 0px 0px 0px;
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 100vw;
  }
`;

const FeedPresentationContainer = styled.div`
  width: 38vw;
  height: auto;

  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 100vw;
  }
`;

export { FeedPageContainer, FeedPresentationContainer };
